import React from "react";
import { Check, X } from "lucide-react";
import { PROBLEMS, METHOD_BENEFITS } from "../mock";
import Reveal from "./ui/Reveal";

export default function Metodo() {
  return (
    <section id="metodo" className="py-24 lg:py-36 relative">
      <div className="container-max">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <Reveal variant="fade-left" className="lg:col-span-5">
            <span className="section-label mb-6 inline-block">Perché è diverso</span>
            <h2 className="font-display text-4xl lg:text-6xl leading-[1] text-white mt-4">
              Il problema<br />
              non sei tu.<br />
              <span className="italic font-light text-white/60">È il metodo.</span>
            </h2>
            <p className="text-white/60 text-base lg:text-lg mt-8 leading-relaxed">
              Se ti riconosci in almeno uno di questi scenari, non è colpa tua. Il problema è che
              nessuno ti ha mai dato un metodo concreto.
            </p>
            <p className="text-white text-lg lg:text-xl mt-6 font-medium">
              Con il nostro percorso tutto questo sarà un vecchio ricordo.
            </p>
          </Reveal>

          <Reveal variant="fade-right" delay={150} className="lg:col-span-7 space-y-3">
            {PROBLEMS.map((p, i) => (
              <div
                key={i}
                className="group bg-card border border-white/10 rounded-xl p-5 lg:p-6 flex gap-4 hover-lift"
              >
                <div className="flex-shrink-0 w-9 h-9 rounded-full border border-white/15 flex items-center justify-center text-white/70 group-hover:border-red-400/40 group-hover:text-red-400/80 transition-colors">
                  <X size={16} />
                </div>
                <p className="text-white/80 text-sm lg:text-base leading-relaxed pt-1">{p}</p>
              </div>
            ))}
          </Reveal>
        </div>

        {/* Method benefits grid */}
        <div className="mt-24 lg:mt-32">
          <div className="flex items-end justify-between flex-wrap gap-6 mb-12">
            <div>
              <span className="section-label">Cosa cambia</span>
              <Reveal variant="zoom" as="h3" className="font-display text-3xl lg:text-5xl text-white mt-4 max-w-2xl leading-tight">
                Un metodo. Quattro promesse mantenute.
              </Reveal>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {METHOD_BENEFITS.map((b, i) => (
              <div
                key={i}
                className="bg-card border border-white/10 rounded-2xl p-6 lg:p-7 hover-lift group"
              >
                <div className="font-mono-label text-[11px] text-white/40">0{i + 1} / 04</div>
                <div className="flex items-center gap-2 mt-4">
                  <div className="w-8 h-8 rounded-full bg-lime flex items-center justify-center">
                    <Check size={14} className="text-black" />
                  </div>
                  <span className="font-display text-white/70 text-sm">{b.key}</span>
                </div>
                <div className="font-display text-2xl lg:text-3xl text-white mt-3">{b.title}</div>
                <p className="text-white/60 text-sm mt-3 leading-relaxed">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
